// @flow
import * as React from "react";
import Periodo, { processarPeriodo } from "./Periodo";
import PeriodoDiario, { processarPeriodoDiario } from "./PeriodoDiario";
import PeriodoDiarioSemPeriodicidade, {
  processarPeriodoDiarioSemPeriodicidade,
} from "./PeriodoDiarioSemPeriodicidade";
import PeriodoSemPeriodicidade, {
  processarPeriodoSemPeriodicidade,
} from "./PeriodoSemPeriodicidade";
import PeriodoDiarioComAtivo, {
  criaFuncaoValidacaoPeriodoDiarioComAtivo,
  processarPeriodoDiarioComAtivo,
} from "./PeriodoDiarioComAtivo";
import PeriodoDiarioComBenchmark, {
  processarPeriodoDiarioComBenchmark,
} from "./PeriodoDiarioComBenchmark";
import PeriodoDiarioComBenchmarkETaxaDeAdministracao, {
  processarPeriodoDiarioComBenchmarkETaxaDeAdministracao,
} from "./PeriodoDiarioComBenchmarkETaxaDeAdministracao";
import PeriodoComAtivoSemRisco, {
  processarPeriodoComAtivoSemRisco,
} from "./PeriodoComAtivoSemRisco";
import PeriodoComAtivoSemRiscoETaxaDeAdministracao, {
  processarPeriodoComAtivoSemRiscoETaxaDeAdministracao,
} from "./PeriodoComAtivoSemRiscoETaxaDeAdministracao";
import PeriodoComBenchmark, {
  processarPeriodoComBenchmark,
} from "./PeriodoComBenchmark";
import PeriodoComBenchmarkEAtivoSemRisco, {
  processarPeriodoComBenchmarkEAtivoSemRisco,
} from "./PeriodoComBenchmarkEAtivoSemRisco";
import PeriodoDiarioComTaxaDeAdministracao, {
  processarPeriodoComTaxaDeAdministracao,
} from "./PeriodoDiarioComTaxaDeAdministracao";
import PeriodoComLambda, {
  processarPeriodoComLambda,
} from "./PeriodoComLambda";
import PeriodoComHcvl, { processarPeriodoComHcvl } from "./PeriodoComHcvl";
import PontualCarteira, { processarPontualCarteira } from "./PontualCarteira";
import Acumulacao, { processarAcumulacao } from "./Acumulacao";
import AcumulacaoDeflator, {
  processarAcumulacaoDeflator,
} from "./AcumulacaoDeflator";
import AcumulacaoCapital, {
  processarAcumulacaoCapital,
} from "./AcumulacaoCapital";
import AcumulacaoPl, { processarAcumulacaoPl } from "./AcumulacaoPl";
import AcumulacaoMercado, {
  processarAcumulacaoMercado,
} from "./AcumulacaoMercado";
import PontualDiario, { processarPontualDiario } from "./PontualDiario";
import PontualDiarioComIndice, {
  criaFuncaoValidacaoPontualDiarioComIndice,
  processarPontualDiarioComIndice,
} from "./PontualDiarioComIndice";
import PontualDiarioSemPeriodicidade, {
  processarPontualDiarioSemPeriodicidade,
} from "./PontualDiarioSemPeriodicidade";
import PontualMensal, { processarPontualMensal } from "./PontualMensal";
import Balanco, { processarBalanco } from "./Balanco";
import Mercado, { processarMercado } from "./Mercado";
import BalancoMercado, { processarBalancoMercado } from "./BalancoMercado";
import BalancoMercadoDeflator, {
  processarBalancoMercadoDeflator,
} from "./BalancoMercadoDeflator";
import BalancoDeflator, { processarBalancoDeflator } from "./BalancoDeflator";
import AcoesPontualDiario, {
  processarAcoesPontualDiario,
} from "./AcoesPontualDiario";
import Ranking, {
  processarRanking,
  criaFuncaoValidacaoRanking,
} from "./Ranking";
import MedidaComposta, {
  processarCriacaoMedida,
  criaFuncaoValidacaoMedidaComposta,
} from "./MedidaComposta";
import MedidaUsuario, {
  criaFuncaoValidacaoMedidaUsuario,
  processarMedidaUsuario,
} from "./MedidaUsuario";
import PontualMensalAtivoComprado, {
  criaFuncaoValidacaoPontualMensalAtivoComprado,
  processarPontualMensalAtivoComprado,
} from "./PontualMensalAtivoComprado";
import PontualMensalComprador, {
  criaFuncaoValidacaoPontualMensalComprador,
  processarPontualMensalComprador,
} from "./PontualMensalComprador";
import PontualMensalCarteiraEmNiveis, {
  processarPontualMensalCarteiraEmNiveis,
} from "./PontualMensalCarteiraEmNiveis";
import PeriodoComLimite, {
  processarPeriodoComLimite,
} from "./PeriodoComLimite";
import PeriodoComIndices, {
  criaFuncaoValidacaoPeriodoComIndices,
  processarPeriodoComIndices,
} from "./PeriodoComIndices";
import SeriesComAjuste, {
  criaFuncaoValidacaoSeriesComAjuste,
  processarSeriesComAjuste,
} from "./SeriesComAjuste";
import SeriesComAjusteEFonte, {
  criaFuncaoValidacaoSeriesComAjusteEFonte,
  processarSeriesComAjusteEFonte,
} from "./SeriesComAjusteEFonte";
import SeriesComAjusteEDeflator, {
  criaFuncaoValidacaoSeriesComAjusteEDeflator,
  processarSeriesComAjusteEDeflator,
} from "./SeriesComAjusteEDeflator";
import SeriesComDeflator, {
  processarSeriesComDeflator,
} from "./SeriesComDeflator";
import SeriesComFonte, { processarSeriesComFonte } from "./SeriesComFonte";
import SeriesComFonteEJanelaMovel, {
  processarSeriesComFonteEJanelaMovel,
} from "./SeriesComFonteEJanela";

import {
  type GeradorMedidasSelecionadas,
  type State,
  adicionarMedidasComDescricao,
  adicionarMedidaUsuario,
  obterMedidasQualitativasSelecionadas,
  getModoExibicaoMedidaSelecionada,
} from "../../../state";

import { type ErrosSelecao } from "../../../model";
import PeriodoComBenchmarkHc, {
  processarPeriodoComBenchmarkHc,
} from "./PeriodoComBenchmarkHc";

import PeriodoComEstatisticas, {
  processarPeriodoComEstatisticas,
} from "./PeriodoComEstatisticas";

import { createSelector } from "reselect";

import { getGrupamentoMedidaSelecionado } from "../../../state/selectors/filtroMedidasSelectors";

import { isMultiplasMedidasSelecionadas } from "../../../util";

import { GRUPAMENTO_MEDIDAS_QUALITATIVAS } from "../../../model";
import PontualDiarioComFlagUltimaNegociacao, {
  processarPontualDiarioComFlagUltimaNegociacao,
} from "./PontualDiarioComFlagUltimaNegociacao";

export const MODO_EXIBICAO_MERCADO = "MERCADO";

type ItemModoExibicao = {
  componente: React.Node,
  geradorMedidasSelecionadas: GeradorMedidasSelecionadas,
  actionCreatorAdicionar: any => any,
  funcaoValidacaoAdicionar?: State => any => ?ErrosSelecao,
};

type MapModosExibicao = {
  [string]: ItemModoExibicao,
};

export const modosExibicao: MapModosExibicao = {
  PERIODO: {
    componente: <Periodo />,
    geradorMedidasSelecionadas: processarPeriodo,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_DIARIO: {
    componente: <PeriodoDiario />,
    geradorMedidasSelecionadas: processarPeriodoDiario,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_DIARIO_SEM_PERIODICIDADE: {
    componente: <PeriodoDiarioSemPeriodicidade />,
    geradorMedidasSelecionadas: processarPeriodoDiarioSemPeriodicidade,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_SEM_PERIODICIDADE: {
    componente: <PeriodoSemPeriodicidade />,
    geradorMedidasSelecionadas: processarPeriodoSemPeriodicidade,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_DIARIO_COM_TAXA_DE_ADMINISTRACAO: {
    componente: <PeriodoDiarioComTaxaDeAdministracao />,
    geradorMedidasSelecionadas: processarPeriodoComTaxaDeAdministracao,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_DIARIO_COM_ATIVO: {
    componente: <PeriodoDiarioComAtivo />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoPeriodoDiarioComAtivo,
    geradorMedidasSelecionadas: processarPeriodoDiarioComAtivo,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_DIARIO_COM_BENCHMARK: {
    componente: <PeriodoDiarioComBenchmark />,
    geradorMedidasSelecionadas: processarPeriodoDiarioComBenchmark,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_DIARIO_COM_BENCHMARK_E_TAXA_DE_ADMINISTRACAO: {
    componente: <PeriodoDiarioComBenchmarkETaxaDeAdministracao />,
    geradorMedidasSelecionadas: processarPeriodoDiarioComBenchmarkETaxaDeAdministracao,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  ACUMULACAO: {
    componente: <Acumulacao />,
    geradorMedidasSelecionadas: processarAcumulacao,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  ACUMULACAO_PL: {
    componente: <AcumulacaoPl />,
    geradorMedidasSelecionadas: processarAcumulacaoPl,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  ACUMULACAO_DEFLATOR: {
    componente: <AcumulacaoDeflator exibirTipoCalculo={false} />,
    geradorMedidasSelecionadas: processarAcumulacaoDeflator,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  ACUMULACAO_DEFLATOR_COM_ANALISE_HORIZONTAL: {
    componente: <AcumulacaoDeflator exibirTipoCalculo={true} />,
    geradorMedidasSelecionadas: processarAcumulacaoDeflator,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  ACUMULACAO_CAPITAL: {
    componente: <AcumulacaoCapital />,
    geradorMedidasSelecionadas: processarAcumulacaoCapital,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  ACUMULACAO_MERCADO: {
    componente: <AcumulacaoMercado />,
    geradorMedidasSelecionadas: processarAcumulacaoMercado,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_LAMBDA: {
    componente: <PeriodoComLambda />,
    geradorMedidasSelecionadas: processarPeriodoComLambda,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_ATIVO_SEM_RISCO: {
    componente: <PeriodoComAtivoSemRisco />,
    geradorMedidasSelecionadas: processarPeriodoComAtivoSemRisco,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_BENCHMARK: {
    componente: <PeriodoComBenchmark />,
    geradorMedidasSelecionadas: processarPeriodoComBenchmark,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_BENCHMARK_E_ATIVO_SEM_RISCO: {
    componente: <PeriodoComBenchmarkEAtivoSemRisco />,
    geradorMedidasSelecionadas: processarPeriodoComBenchmarkEAtivoSemRisco,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_ATIVO_SEM_RISCO_E_TAXA_DE_ADMINISTRACAO: {
    componente: <PeriodoComAtivoSemRiscoETaxaDeAdministracao />,
    geradorMedidasSelecionadas: processarPeriodoComAtivoSemRiscoETaxaDeAdministracao,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_HCVL: {
    componente: <PeriodoComHcvl />,
    geradorMedidasSelecionadas: processarPeriodoComHcvl,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PONTUAL_CARTEIRA: {
    componente: <PontualCarteira />,
    geradorMedidasSelecionadas: processarPontualCarteira,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PONTUAL_DIARIO: {
    componente: <PontualDiario />,
    geradorMedidasSelecionadas: processarPontualDiario,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PONTUAL_DIARIO_COM_FLAG_ULTIMA_NEGOCIACAO: {
    componente: <PontualDiarioComFlagUltimaNegociacao />,
    geradorMedidasSelecionadas: processarPontualDiarioComFlagUltimaNegociacao,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PONTUAL_DIARIO_COM_INDICE: {
    componente: <PontualDiarioComIndice />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoPontualDiarioComIndice,
    geradorMedidasSelecionadas: processarPontualDiarioComIndice,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PONTUAL_DIARIO_SEM_PERIODICIDADE: {
    componente: <PontualDiarioSemPeriodicidade />,
    geradorMedidasSelecionadas: processarPontualDiarioSemPeriodicidade,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PONTUAL_MENSAL: {
    componente: <PontualMensal />,
    geradorMedidasSelecionadas: processarPontualMensal,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  BALANCO: {
    componente: <Balanco />,
    geradorMedidasSelecionadas: processarBalanco,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  MERCADO: {
    componente: <Mercado />,
    geradorMedidasSelecionadas: processarMercado,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  BALANCO_MERCADO: {
    componente: <BalancoMercado />,
    geradorMedidasSelecionadas: processarBalancoMercado,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  BALANCO_MERCADO_DEFLATOR: {
    componente: <BalancoMercadoDeflator />,
    geradorMedidasSelecionadas: processarBalancoMercadoDeflator,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  BALANCO_DEFLATOR: {
    componente: <BalancoDeflator />,
    geradorMedidasSelecionadas: processarBalancoDeflator,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  ACOES_PONTUAL_DIARIO: {
    componente: <AcoesPontualDiario />,
    geradorMedidasSelecionadas: processarAcoesPontualDiario,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  MEDIDA_QUALITATIVA: {
    componente: null,
    geradorMedidasSelecionadas: obterMedidasQualitativasSelecionadas,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  RANKING: {
    componente: <Ranking />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoRanking,
    geradorMedidasSelecionadas: processarRanking,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  MEDIDA_COMPOSTA: {
    componente: <MedidaComposta />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoMedidaComposta,
    geradorMedidasSelecionadas: processarCriacaoMedida,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  MEDIDA_USUARIO: {
    componente: <MedidaUsuario />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoMedidaUsuario,
    geradorMedidasSelecionadas: processarMedidaUsuario,
    actionCreatorAdicionar: adicionarMedidaUsuario,
  },
  PONTUAL_MENSAL_ATIVO_COMPRADO: {
    componente: <PontualMensalAtivoComprado />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoPontualMensalAtivoComprado,
    geradorMedidasSelecionadas: processarPontualMensalAtivoComprado,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PONTUAL_MENSAL_COMPRADOR: {
    componente: <PontualMensalComprador />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoPontualMensalComprador,
    geradorMedidasSelecionadas: processarPontualMensalComprador,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PONTUAL_MENSAL_CARTEIRA_EM_NIVEIS: {
    componente: <PontualMensalCarteiraEmNiveis />,
    geradorMedidasSelecionadas: processarPontualMensalCarteiraEmNiveis,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_LIMITE: {
    componente: <PeriodoComLimite />,
    geradorMedidasSelecionadas: processarPeriodoComLimite,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_BENCHMARK_HC: {
    componente: <PeriodoComBenchmarkHc />,
    geradorMedidasSelecionadas: processarPeriodoComBenchmarkHc,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_ESTATISTICAS: {
    componente: <PeriodoComEstatisticas />,
    geradorMedidasSelecionadas: processarPeriodoComEstatisticas,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  PERIODO_COM_INDICES: {
    componente: <PeriodoComIndices />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoPeriodoComIndices,
    geradorMedidasSelecionadas: processarPeriodoComIndices,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  SERIES_COM_AJUSTE: {
    componente: <SeriesComAjuste />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoSeriesComAjuste,
    geradorMedidasSelecionadas: processarSeriesComAjuste,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  SERIES_COM_AJUSTE_E_DEFLATOR: {
    componente: <SeriesComAjusteEDeflator />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoSeriesComAjusteEDeflator,
    geradorMedidasSelecionadas: processarSeriesComAjusteEDeflator(false),
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  SERIES_COM_AJUSTE_DEFLATOR_FLAG_ULTIMA_NEGOCIACAO: {
    componente: <SeriesComAjusteEDeflator />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoSeriesComAjusteEDeflator,
    geradorMedidasSelecionadas: processarSeriesComAjusteEDeflator(true),
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  SERIES_COM_AJUSTE_E_FONTE: {
    componente: <SeriesComAjusteEFonte />,
    funcaoValidacaoAdicionar: criaFuncaoValidacaoSeriesComAjusteEFonte,
    geradorMedidasSelecionadas: processarSeriesComAjusteEFonte,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  SERIES_COM_DEFLATOR: {
    componente: <SeriesComDeflator />,
    geradorMedidasSelecionadas: processarSeriesComDeflator,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  SERIES_COM_FONTE: {
    componente: <SeriesComFonte />,
    geradorMedidasSelecionadas: processarSeriesComFonte,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
  SERIES_COM_FONTE_E_JANELA_MOVEL: {
    componente: <SeriesComFonteEJanelaMovel />,
    geradorMedidasSelecionadas: processarSeriesComFonteEJanelaMovel,
    actionCreatorAdicionar: adicionarMedidasComDescricao,
  },
};

const getMedidaQualiOuModoExibicao = createSelector(
  getGrupamentoMedidaSelecionado,
  getModoExibicaoMedidaSelecionada,
  (grupamentoMedidaSelecionado, modoExibicaoSelecionado) => {
    switch (grupamentoMedidaSelecionado) {
      case GRUPAMENTO_MEDIDAS_QUALITATIVAS:
        return "MEDIDA_QUALITATIVA";
      default:
        return modoExibicaoSelecionado;
    }
  }
);

export const getActionCreatorAdicionar = createSelector(
  getMedidaQualiOuModoExibicao,
  modoExibicaoSelecionado => {
    return modoExibicaoSelecionado
      ? isMultiplasMedidasSelecionadas(modoExibicaoSelecionado)
        ? // $FlowFixMe: Devido a maneira como modoExibicaoSelecionado foi definido, o Flow lança um erro ao usar como Array
          modoExibicaoSelecionado.map(modo => {
            return modosExibicao[modo].actionCreatorAdicionar;
          })
        : modosExibicao[modoExibicaoSelecionado].actionCreatorAdicionar
      : state => null;
  }
);

export const getGeradorMedidasSelecionadas = createSelector(
  getMedidaQualiOuModoExibicao,
  modoExibicaoSelecionado => {
    return modoExibicaoSelecionado
      ? isMultiplasMedidasSelecionadas(modoExibicaoSelecionado)
        ? // $FlowFixMe: Devido a maneira como modoExibicaoSelecionado foi definido, o Flow lança um erro ao usar como Array
          modoExibicaoSelecionado.map(
            modo => modosExibicao[modo].geradorMedidasSelecionadas
          )
        : modosExibicao[modoExibicaoSelecionado].geradorMedidasSelecionadas
      : state => [];
  }
);
